module.exports = __webpack_public_path__ + "images/kurtosis-faq-01-desktop.png";